<script lang="ts">
  const { size = 24 }: { size?: number | string } = $props();
</script>
<svg
  width={size}
  height={size}
  viewBox="0 0 24 24"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect
    x="3"
    y="4"
    width="18"
    height="18"
    rx="2"
    ry="2"
  />
  <line
    x1="16"
    y1="2"
    x2="16"
    y2="6"
  />
  <line
    x1="8"
    y1="2"
    x2="8"
    y2="6"
  />
  <path
    class='star'
    style="fill:currentColor;stroke:none"
    d="m 11.999999,7 a 1.0023827,0.99752288 0 0 0 -0.898903,0.5555696 l -1.3107775,2.6438114 -2.9329022,0.42639 a 1.0023827,0.99752288 0 0 0 -0.5543722,1.701675 l 2.12184,2.055219 -0.5006917,2.905084 a 1.0023827,0.99752288 0 0 0 1.4542509,1.05092 l 2.6215557,-1.371441 2.621557,1.371441 a 1.0023827,0.99752288 0 0 0 1.45425,-1.05092 l -0.500692,-2.905084 2.121841,-2.055219 A 1.0023827,0.99752288 0 0 0 17.142583,10.625771 L 14.20968,10.199381 12.898902,7.5555696 A 1.0023827,0.99752288 0 0 0 11.999999,7 Z"
  />
</svg>

<style lang='scss'>
  @use '~/theme/theme.scss';

  .star {
    color: theme.$star-bonus;
  }
</style>